import { render, staticRenderFns } from "./CreateContractChange.vue?vue&type=template&id=39af9b2a"
import script from "./CreateContractChange.vue?vue&type=script&lang=js"
export * from "./CreateContractChange.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports